import React, {useEffect} from "react";
import styled from "styled-components";
import useLockBodyScroll from "../hooks/useLockBody";
import {Link} from "react-router-dom";
import Color from "../assets/Colors";
import {ReactComponent as CloseIcon} from "../assets/icons/close.svg";
import {useLocation, useHistory} from "react-router-dom";
import {ResetButton} from "./Button";

function Modal({children, back, type}) {
   let location = useLocation();
   let history = useHistory();
   useLockBodyScroll();

   useEffect(() => {
      document.addEventListener("keydown", escFunction, false);
      return () => {
         document.removeEventListener("keydown", escFunction, false);
      };
   });
   function escFunction(event) {
      if (event.keyCode === 27) {
         closeFunction();
      }
   }

   const closeFunction = () => {
      history.goBack();
   };

   if (type === "video") {
      return (
         <ModalContainer back={back}>
            <div className="back-modal" onDoubleClick={closeFunction} />
            <div className="contentModal">
               <VideoContent>
                  {children}
                  <ResetButton onClick={closeFunction}>
                     <CloseIcon width="1em" height="1em" fill="white" />
                  </ResetButton>
               </VideoContent>
            </div>
         </ModalContainer>
      );
   }

   return (
      <ModalContainer back={back}>
         <div className="back-modal" onDoubleClick={closeFunction} />
         <div className="contentModal">
            <CardModal>
               <HeadModal>
                  <img src={require("../assets/logo/domecq_academy.png")} alt="logo" className="logoModal" />
                  <CloseButton to={location.pathname}>
                     <CloseIcon width="2em" height="2em" className="closeIcon" fill={Color.textColor} />
                  </CloseButton>
               </HeadModal>
               {children}
            </CardModal>
         </div>
      </ModalContainer>
   );
}

const ModalContainer = styled.section`
   width: 100%;
   height: 100%;
   position: fixed;
   top: 0;
   left: 0;
   z-index: 100000;

   & .contentModal {
      width: 100%;
      height: 100%;
      overflow: scroll;
      display: flex;
      justify-content: center;
      align-items: flex-start;
   }

   & .back-modal {
      background: ${(props) => props.back || "rgba(50, 50, 50, 0.5)"};
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
   }

   @media screen and (max-width: 600px) {
      padding-top: 1em;
   }
`;

const CardModal = styled.div`
   width: 30%;
   max-width: 620px;
   background: white;
   position: relative;
   padding: 3em;
   padding-top: 1em;
   // padding-bottom: 140px;
   margin: 4vh 0;
   @media screen and (max-width: 1600px) {
      width: 40%;
      max-width: 450px;
   }

   @media screen and (max-width: 500px) {
      width: 95%;
      max-width: 650px;
   }
`;

const HeadModal = styled.div`
   width: 100%;
   background-color: transparent;
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 1em;

   & .logoModal {
      width: 250px;
      // margin-left: -35px;
   }

   @media screen and (max-width: 1600px) {
      & .logoModal {
         width: 150px;
         // margin-left: -25px;
      }
   }
`;
const CloseButton = styled(Link)`
   color: ${Color.textColor};
   font-weight: 100;
   @media screen and (max-width: 1600px) {
      & .closeIcon {
         width: 1.01em;
         height: 1.01em;
      }
   }
`;

export default Modal;

const VideoContent = styled.div`
   position: relative;
   padding: 0;
   width: 70%;
   margin: 0 auto;
   margin-top: 10%;

   @media screen and (max-width: 1600px) {
      margin-top: 5%;
      width: 60%;
   }

   @media screen and (max-width: 500px) {
      width: 95%;
   }

   & ${ResetButton} {
      position: absolute;
      top: 0;
      right: 0;
      width: 2em;
      height: 2em;
      border-radius: 50%;
      margin: 0.5em;

      &:hover {
         background: rgba(250, 250, 250, 0.3);
      }
   }
`;
